import React from 'react';

/**
 * Google Material Symbols Outlined "info"
 * (FILL 0, wght 400, GRAD 0, opsz 24, color #737373 via CSS).
 * @param {boolean} [disabled] - Muted when true (e.g. email not verified).
 * @param {boolean} [menuInline] - Slightly smaller glyph for inline menu labels.
 */
export default function InfoIconMaterial({ disabled, menuInline, className = '', style, ...rest }) {
  return (
    <span
      className={`material-symbols-outlined material-symbols-info${disabled ? ' material-symbols-info--disabled' : ''}${menuInline ? ' material-symbols-info--menu-inline' : ''}${className ? ` ${className}` : ''}`}
      aria-hidden="true"
      style={style}
      {...rest}
    >
      info
    </span>
  );
}
